/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './cookieButton.module.scss';

export default function CookieButton(props) {
  const { className = '' } = props;
  const [t] = useTranslation();

  return (
    <div>
      <div
        data-testid="cookie-btn"
        type="button"
        id="hs_show_banner_button"
        className={` ${styles[className]}`}
        onClick={() => {
          // eslint-disable-next-line no-multi-assign
          const _hsp = (window._hsp = window._hsp || []);
          _hsp.push(['showBanner']);
        }}
        aria-hidden="true"
      >
        {t('common.footer.cookie').toUpperCase()}
      </div>
    </div>
  );
}
